export const getDateFromISOString = (isoString: string) => isoString?.split('T')[0];